import { QueryClient } from 'react-query';

/**
 * The app's ONE query client.
 *
 * It lives here rather than in App so that SIGN-OUT can reach it. `AuthProvider` is mounted
 * ABOVE `QueryClientProvider` (see index.tsx), so `useQueryClient()` does not resolve where
 * `logout` is defined, and the cache simply outlived the session as a result.
 *
 * That was survivable while every cache entry was one screen's rows. It stopped being
 * survivable once `pagination.ts` began sharing WHOLE flag-off list responses under an
 * endpoint-wide key: the customer, user and organisation lists are then the entire table,
 * cached for `cacheTime`, and this is a single-page app — signing out navigates, it does not
 * reload. The next operator to sign in on the same tab was being answered from a copy
 * fetched under the previous operator's credentials.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});
